// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slider_wrapper__3L8RP","slider":"Slider_slider__3ML99","yAxis":"Slider_yAxis__2sTEL"};